import { HttpMethod } from '../../components/Common/useFetch';
import { RequestOptions } from '../../components/Common/useRequest';
import useUserOrKaEmployeeRequest from '../../components/Common/useUserOrEmployeeRequest';
import { useUserOrKaEmployee } from '../../components/UserAccess/useUserOrKaEmployee';

export interface ValidateFieldAlyticsCredentialsRequest {
  username: string;
}

const useValidateFieldAlyticsCredentials = (options?: RequestOptions) => {
  const { selectedBusiness } = useUserOrKaEmployee();
  return useUserOrKaEmployeeRequest<ValidateFieldAlyticsCredentialsRequest>(
    { path: `/api/integrations/fieldalytics/${selectedBusiness?.id}/settings/validate`, method: HttpMethod.POST },
    options
  );
};

export default useValidateFieldAlyticsCredentials;
